<template>
  <BOverlay
    id="scroll"
    :show="loading"
    spinner-variant="primary"
    variant="light"
    blur="0"
    opacity=".5"
    rounded="sm"
  >
    <div
      id="table"
      class="overflow-y-auto h-[50vh]"
      @scroll="handleScroll"
    >
      <BTable
        :items="items"
        :fields="fields"
        empty-text="Tidak ada data yang ditampilkan."
        responsive
        show-empty
      >
        <template #head(select)>
          <BFormCheckbox
            :checked="isSelectedAll"
            :disabled="items.length < 1"
            @change="selectAll"
          />
        </template>
        <template #cell(select)="data">
          <BFormCheckbox
            :checked="isSelected(data.item.user_id)"
            @change="toggleSelection(data.item.user_id)"
          />
        </template>
        <template #cell(name)="data">
          <div>
            <p class="text-[14px] text-black font-medium mb-[.5rem]">
              {{ data.item.full_name }}
            </p>
            <p class="text-[12px] text-[#828282] m-0">
              {{ data.item.position_name }}
            </p>
          </div>
        </template>
        <template
          v-for="(day, dayIndex) in 7"
          v-slot:[`cell(day_${day})`]="data"
        >
          <div
            :key="dayIndex"
            class="flex flex-col items-center justify-center gap-[.5rem]"
            :class="configStyles[data.item.schedule[dayIndex].work_mode] || ''"
          >
            <span class="text-[14px] font-semibold">{{ data.item.schedule[dayIndex].work_mode }}</span>
            <span class="text-[12px] text-[#828282] text-nowrap">{{ data.item.schedule[dayIndex].check_in_time }} - {{ data.item.schedule[dayIndex].check_out_time }}</span>
          </div>
        </template>
        <template #cell(action)="data">
          <BButton
            variant="link"
            @click="handleEditWorkConfig(data.item)"
          >
            <span class="k-edit text-[20px] text-[#626262]" />
          </BButton>
        </template>
      </BTable>
    </div>
  </BOverlay>
</template>

<style scoped>
.badge-config-success, .badge-config-info {
    padding: .5rem;
    @apply rounded-lg
}

.badge-config-success {
    background-color: #EDF8ED;
    border: 1px solid #DDEFE0;
    color: #10673E;
}

.badge-config-info {
    background-color: #E1EDFF;
    border: 1px solid #CEDEFF;
    color: #376FCB;
}
</style>

<script>
import { tableUsersWorkConfig } from './config'

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
      default: () => ({
        division: null,
        keyword: '',
        selectedItems: [],
      }),
    },
  },
  data() {
    return {
      fields: tableUsersWorkConfig,
      selectedConfigs: {},
      configStyles: {
        WFO: 'badge-config-success',
        WFH: 'badge-config-info',
      },
    }
  },
  computed: {
    /**
     * Check if all users are selected
     */
    isSelectedAll() {
      if (this.items.length < 1) return false
      return Object.keys(this.selectedConfigs).length === this.items.length
    },
  },
  watch: {
    /**
     * Reset selected configs when keyword filter changes
     */
    'filter.keyword': {
      handler() {
        _.debounce(this.resetSelectedConfigs, 1000)()
      },
    },
    /**
     * Reset selected configs when division filter changes
     */
    'filter.division': {
      handler() {
        _.debounce(this.resetSelectedConfigs, 1000)()
      },
    },
    /**
     * Reset selected configs when selected items change
     */
    'filter.selectedItems': {
      handler(value) {
        if (value.length < 1) {
          this.resetSelectedConfigs()
        }
      },
    },
  },
  methods: {
    /**
     * Handle scroll event
     */
    handleScroll(event) {
      this.$emit('scroll', event)
    },
    /**
     * Check if user is selected
     */
    isSelected(userId) {
      return userId in this.selectedConfigs
    },
    /**
     * Toggle user selection
     */
    toggleSelection(userId) {
      if (this.selectedConfigs[userId]) {
        this.$delete(this.selectedConfigs, userId)
      } else {
        this.$set(this.selectedConfigs, userId, true)
      }
      this.$emit('selection-change', this.selectedConfigs)
    },
    /**
     * Select all users
     */
    selectAll(isChecked) {
      if (isChecked) {
        const result = {}
        this.items.forEach(item => {
          this.$set(result, item.user_id, true)
        })

        this.selectedConfigs = result
      } else {
        this.selectedConfigs = {}
      }

      this.$emit('selection-change', this.selectedConfigs)
    },
    /**
     * Handle edit work configuration
     */
    handleEditWorkConfig(item) {
      this.$emit('edit-work-config', item)
    },
    /**
     * Reset selected configs
     */
    resetSelectedConfigs() {
      this.selectedConfigs = {}
      if (this.filter.selectedItems.length > 0) {
        this.$emit('selection-change', this.selectedConfigs)
      }
    },
  },
}
</script>
